<div class="create-invoice-dialog">
  <div class="dialog-header">
    <h2>Create Invoice</h2>
    <mat-icon class="close-icon" (click)="closeDialog()">close</mat-icon>
  </div>

  <form [formGroup]="invoiceForm" class="invoice-form">
    <div class="form-section">
      <h3>Invoice Details</h3>
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Invoice Number</mat-label>
          <input matInput formControlName="invoiceNumber">
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Invoice Date</mat-label>
          <input matInput [matDatepicker]="invoiceDatePicker" formControlName="invoiceDate">
          <mat-datepicker-toggle matSuffix [for]="invoiceDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #invoiceDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Due Date</mat-label>
          <input matInput [matDatepicker]="dueDatePicker" formControlName="dueDate">
          <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #dueDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="form-section">
      <h3>Client Information</h3>
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field full-width">
          <mat-label>Client Name / Company</mat-label>
          <input matInput formControlName="clientName" placeholder="Enter client name or select from codebook">
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>VAT Number</mat-label>
          <input matInput formControlName="clientVatNumber">
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>ID Number</mat-label>
          <input matInput formControlName="clientIdNumber">
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field full-width">
          <mat-label>Address</mat-label>
          <input matInput formControlName="clientAddress">
        </mat-form-field>
      </div>
    </div>

    <div class="form-section">
      <h3>Line Items</h3>
      <div class="line-items-header">
        <span class="col-description">Description</span>
        <span class="col-quantity">Qty</span>
        <span class="col-price">Unit Price</span>
        <span class="col-vat">VAT %</span>
        <span class="col-vat-amount">VAT Amount</span>
        <span class="col-total">Total</span>
        <span class="col-actions"></span>
      </div>

      <div formArrayName="lineItems">
        <div *ngFor="let item of lineItems.controls; let i = index" [formGroupName]="i" class="line-item-row">
          <mat-form-field appearance="outline" class="col-description">
            <input matInput formControlName="description" placeholder="Item description">
          </mat-form-field>

          <mat-form-field appearance="outline" class="col-quantity">
            <input matInput type="number" formControlName="quantity" (input)="calculateLineItem(i)">
          </mat-form-field>

          <mat-form-field appearance="outline" class="col-price">
            <input matInput type="number" formControlName="unitPrice" (input)="calculateLineItem(i)">
          </mat-form-field>

          <mat-form-field appearance="outline" class="col-vat">
            <input matInput type="number" formControlName="vatRate" (input)="calculateLineItem(i)">
          </mat-form-field>

          <div class="col-vat-amount calculated-field">
            {{ item.get('vatAmount')?.value | number:'1.2-2' }}
          </div>

          <div class="col-total calculated-field">
            {{ item.get('totalWithVat')?.value | number:'1.2-2' }}
          </div>

          <div class="col-actions">
            <button mat-icon-button color="warn" (click)="removeLineItem(i)" *ngIf="lineItems.length > 1">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <button mat-stroked-button color="primary" (click)="addLineItem()" class="add-item-btn">
        <mat-icon>add</mat-icon>
        Add Line Item
      </button>
    </div>

    <div class="form-section totals-section">
      <div class="totals-row">
        <span class="totals-label">Subtotal (without VAT):</span>
        <span class="totals-value">{{ subtotal | number:'1.2-2' }} BAM</span>
      </div>
      <div class="totals-row">
        <span class="totals-label">Total VAT:</span>
        <span class="totals-value">{{ totalVat | number:'1.2-2' }} BAM</span>
      </div>
      <div class="totals-row grand-total">
        <span class="totals-label">Grand Total:</span>
        <span class="totals-value">{{ grandTotal | number:'1.2-2' }} BAM</span>
      </div>
    </div>

    <div class="form-section">
      <mat-form-field appearance="outline" class="form-field full-width">
        <mat-label>Payment Terms</mat-label>
        <input matInput formControlName="paymentTerms">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field full-width">
        <mat-label>Notes</mat-label>
        <textarea matInput formControlName="notes" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="form-section">
      <h3>Memorandum <span class="required-marker">*</span></h3>
      <p class="memorandum-description">Upload a memorandum (.docx) file. It will be converted to PDF and saved as the invoice.</p>

      <!-- Saved memorandum option -->
      <div *ngIf="hasSavedMemorandum && !memorandumFile" class="saved-memorandum-section">
        <div class="saved-memorandum-info" *ngIf="useSavedMemorandum">
          <mat-icon class="file-icon" style="color: #4caf50;">check_circle</mat-icon>
          <span class="file-name">Using saved: {{ savedMemorandumFileName }}</span>
        </div>
        <div class="memorandum-toggle-actions">
          <button mat-stroked-button [color]="useSavedMemorandum ? 'primary' : ''" 
            (click)="toggleUseSavedMemorandum(true)" class="toggle-btn">
            <mat-icon>history</mat-icon>
            Use Saved Memorandum
          </button>
          <input type="file" accept=".docx" (change)="onMemorandumFileSelected($event); toggleUseSavedMemorandum(false)" #memorandumInputSaved hidden>
          <button mat-stroked-button [color]="!useSavedMemorandum ? 'primary' : ''" 
            (click)="memorandumInputSaved.click()" class="toggle-btn">
            <mat-icon>upload_file</mat-icon>
            Upload New
          </button>
        </div>
      </div>

      <!-- First-time upload (no saved memorandum) -->
      <div class="memorandum-upload" *ngIf="!hasSavedMemorandum && !memorandumFile">
        <input type="file" accept=".docx" (change)="onMemorandumFileSelected($event)" #memorandumInput hidden>
        <button mat-stroked-button color="primary" (click)="memorandumInput.click()" class="upload-memorandum-btn">
          <mat-icon>upload_file</mat-icon>
          Upload Memorandum (.docx)
        </button>
      </div>

      <!-- Newly uploaded file info -->
      <div class="memorandum-file-info" *ngIf="memorandumFile">
        <mat-icon class="file-icon">description</mat-icon>
        <span class="file-name">{{ memorandumFileName }}</span>
        <button mat-icon-button color="warn" (click)="removeMemorandum()" matTooltip="Remove file">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </form>

  <div class="dialog-actions">
    <button mat-stroked-button (click)="closeDialog()">Cancel</button>
    <button mat-raised-button color="primary" (click)="saveInvoice()">
      <mat-icon>save</mat-icon>
      Save Invoice
    </button>
  </div>
</div>
